import { Col, Row } from "antd";
import { RouteConfigComponentProps } from "react-router-config";
import SearchForm from "./SearchForm/SearchForm";
import ResultsScreen from "./ResultsScreen/ResultsScreen";
import useBusquedaImagen from "../../shared/hooks/useBusquedaImagen";
import { useCheckAuthority } from "../../shared/CustomHooks";

import "./style.less";

export interface IImagenInput {
  patente: string;
}

const BusquedaImagenes = (
  routeProps: RouteConfigComponentProps
): JSX.Element => {
  const {
    getImagenes,
    imagenes,
    clearButton,
    loading,
    cleanSearch,
    formValuesOnLoad,
    termSearched,
  } = useBusquedaImagen();

  return (
    useCheckAuthority(routeProps) || (
      <div className="BusquedaImagenesLayout">
        <Row>
          <Col xs={24} sm={24} lg={24} xl={8} xxl={7} className="search-side">
            <SearchForm
              getImagenes={getImagenes}
              clearButton={clearButton}
              cleanSearch={cleanSearch}
              formValuesOnLoad={formValuesOnLoad}
            />
          </Col>
          <Col
            xs={24}
            sm={24}
            lg={24}
            xl={15}
            xxl={16}
            className="results-side"
            style={{ padding: 20 }}
          >
            <ResultsScreen
              imagenes={imagenes}
              loading={loading}
              cleanSearch={cleanSearch}
              termSearched={termSearched}
            />
          </Col>
        </Row>
      </div>
    )
  );
};

export default BusquedaImagenes;
